// src/components/shared/DonationAmountModal.js
import React, { useState } from "react";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { Heart } from "lucide-react";

const DonationAmountModal = ({ isOpen, onClose, onContinue, campaign }) => {
  const [amount, setAmount] = useState(100);
  const [customAmount, setCustomAmount] = useState("");

  const predefinedAmounts = [100, 250, 500, 1000];

  const handleCustomAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setCustomAmount(value);
    setAmount(Number(value));
  };

  const handleContinue = () => {
    if (amount > 0) {
      onContinue(amount); // Pass the final amount back to the parent
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Donate to ${campaign.title}`}
    >
      <div className="p-4">
        <div className="bg-white p-6 rounded-xl border border-slate-200">
          <h3 className="text-md font-bold text-slate-800 text-center mb-4">
            Choose Amount (ETB)
          </h3>
          <div className="grid grid-cols-2 gap-3 mb-4">
            {predefinedAmounts.map((predefined) => (
              <Button
                key={predefined}
                variant={
                  amount === predefined && customAmount === ""
                    ? "primary"
                    : "outline"
                }
                onClick={() => {
                  setAmount(predefined);
                  setCustomAmount("");
                }}
              >
                {predefined.toLocaleString()}
              </Button>
            ))}
          </div>
          <input
            type="text"
            value={customAmount}
            onChange={handleCustomAmountChange}
            placeholder="Or enter custom amount"
            className="w-full text-center px-3 py-2 bg-slate-100 border border-slate-200 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
          />
        </div>
        <div className="mt-6">
          <Button
            onClick={handleContinue}
            className="w-full"
            size="lg"
            disabled={amount <= 0}
          >
            <Heart size={16} className="mr-2" />
            Continue to Donate{" "}
            {amount > 0 ? amount.toLocaleString() + " ETB" : ""}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DonationAmountModal;
